//Libraries
import React from "react";
import Helmet from "react-helmet";
import isEmpty from "lodash/isEmpty";
import { useHistory } from "react-router";

//Types
import { IMapOfString } from "global";
import { CANONICAL_HOMEPAGE_URL } from "shared/constants/pages";

// text constants
import { DEFAULT_META } from "./texts";

interface IMetaDataProps {
    metaData: IMapOfString;
}

const MetaInfo = ({ metaData }: IMetaDataProps) => {
    if (isEmpty(metaData)) {
        metaData = DEFAULT_META;
    }

    const { description = "", title = "", keywords = "" } = metaData;

    const { location } = useHistory();

    let CANONICAL_URL = CANONICAL_HOMEPAGE_URL + location.pathname;

    if (location.pathname.indexOf("/lp/") > -1) {
        const params = new URLSearchParams(location.search);
        CANONICAL_URL += `?pageType=${params.get("pageType")}`;

        if (params.has("pageVariation")) {
            CANONICAL_URL += `pageVariation=${params.get("pageVariation")}`;
        }
    }

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={CANONICAL_URL} />
        </Helmet>
    );
};

export default MetaInfo;
